import { Component, OnInit } from "@angular/core"

@Component({
    selector: "app-change-log",
    templateUrl: "./change-log.component.html",
    styleUrls: ["./change-log.component.scss"],
})
export class ChangeLogComponent implements OnInit {
    checkedPwd = false
    showPassC1 = false
    pwd
    constructor() {}

    ngOnInit(): void {}
    checkPass() {
        if (this.pwd == "bonusza007") {
            this.checkedPwd = true
        } else {
            this.checkedPwd = false
        }
    }
}
